import React from 'react';
import type { FC } from 'react';
import { SiteProvider } from '../../site/index.js';
import { Preview } from './Preview.js';
import type { PreviewData } from './Preview.js';
import { ExtensionDataProvider } from '../../context/extensionData.js';

export const PreviewCommand: FC<{
  baseUrl?: string;
  siteIdOverride?: string;
  onPreviewCreated?: (data: PreviewData) => void;
}> = ({ baseUrl, siteIdOverride, onPreviewCreated }) => {
  return (
    <SiteProvider siteId={siteIdOverride}>
      <ExtensionDataProvider>
        <Preview baseUrl={baseUrl} onPreviewCreated={onPreviewCreated} />
      </ExtensionDataProvider>
    </SiteProvider>
  );
};
